import { Section, useScrollSection } from "react-scroll-section";
import Code from "../assets/code.svg";
import Html from "../assets/html.svg";
import Css from "../assets/css.svg";
import Javascript from "../assets/js.svg";
import ReactIcon from "../assets/react.svg";
import Redux from "../assets/redux.svg";
import Node from "../assets/node.svg";
import Mongo from "../assets/mongodb.svg";
import Firebase from "../assets/firebase.svg";

import Psql from "../assets/psql.svg";

import Next from "../assets/next.svg";
import TypeScript from "../assets/typescript.svg";
import Express from "../assets/express.svg"
import "../style/css/Technologies.css";
import { motion } from "framer-motion";
function Technologies() {
  const technologies = useScrollSection("technologies");

  return (
    <Section id="technologies" style={{ width: "100%" }}>
      <motion.div className="container t-container">
        <div className="orbit">
          <div className="center-image">
            <img src={Code} alt="" />
          </div>
          <ul className={technologies.selected ? "active" : ""}>
            <li className={technologies.selected ? "active" : ""}>
              <div>
                <img src={Javascript} alt="" className="icons" />
              </div>
              <p>JavaScript</p>
            </li>
            <li className={technologies.selected ? "active" : ""}>
              <div>
                <img src={TypeScript} alt="" className="icons" />
              </div>
              <p>TypeScript</p>
            </li>
            <li className={technologies.selected ? "active" : ""}>
              <div>
                <img src={ReactIcon} alt="" className="icons" />
              </div>
              <p>React.js</p>
            </li>
            <li className={technologies.selected ? "active" : ""}>
              <div>
                <img src={Redux} alt="" className="icons" />
              </div>
              <p>Redux</p>
            </li>
            <li className={technologies.selected ? "active" : ""}>
              <div>
                <img src={Node} alt="" />
              </div>
              <p>Node.js</p>
            </li>
            <li className={technologies.selected ? "active" : ""}>
              <div>
                <img src={Express} alt="" />
              </div>
              <p>Express.js</p>
            </li>
            <li className={technologies.selected ? "active" : ""}>
              <div>
                <img src={Firebase} alt="" className="icons" />
              </div>
              <p>Firebase</p>
            </li>
            <li className={technologies.selected ? "active" : ""}>
              <div>
                <img src={Mongo} alt="" className="icons" />
              </div>
              <p>Mongo DB</p>
            </li>
            <li className={technologies.selected ? "active" : ""}>
              <div>
                <img src={Psql} alt="" className="icons" />
              </div>
              <p>Psql</p>
            </li>
            <li className={technologies.selected ? "active" : ""}>
              <div>
                <img src={Next} alt="" className="icons" />
              </div>
              <p>Next.js</p>
            </li>
          </ul>
        </div>
      </motion.div>
    </Section>
  );
}

export default Technologies;
